__turbopack_context__.v({
  "badge": "kS1kYW_badge",
  "counted": "kS1kYW_counted",
  "pill": "kS1kYW_pill",
  "ribbon": "kS1kYW_ribbon",
});
